import { render, staticRenderFns } from "./template.html?vue&type=template&id=57bcd795&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=57bcd795&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bcd795",
  null
  
)

export default component.exports